// TODO: use nested bank object instead
import {Proof} from './Proof';
export class BankAccount {
    _id: string;
    account_no: string;
    account_type: string;
    accountHolderName: string;
    bank_name: string;
    branch_name: string;
    branch_city: string;
    ifsc: string;
    userId: string;
    proofs: Proof[];

    constructor();
    constructor(accountNo: string,
                accountType: string,
                accountHolderName: string,
                bankName: string,
                bankBranchName: string,
                bankCity: string,
                bankIfsc: string,
                userId: string,
    )
    constructor(accountNumber?: string,
                accountType?: string,
                accountHolderName?: string,
                bankName?: string,
                bankBranchName?: string,
                bankCity?: string,
                bankIfsc?: string,
                userId?: string
    ) {
        this.account_no = accountNumber;
        this.account_type = accountType;
        this.accountHolderName = accountHolderName;
        this.bank_name = bankName;
        this.branch_name = bankBranchName;
        this.branch_city = bankCity;
        this.ifsc = bankIfsc;
        this.userId = userId;
    }
}
